export const SelectCamera = () => {
    return (
        <div className="select-camera">
            <p className="select-camera__text">
                Select camera for generation
            </p>
        </div>
    )
}